export default class DashboardState {
  constructor() {
    this.dashboard = {
      loading: false,
      data: {},
      error: null,
    };

    this.supplierDocument = {
      loading: false,
      data: [],
      total: 0,
      error: null,
    };

    this.auditCertification = {
      loading: false,
      data: [],
      total: 0,
      error: null,
    };

    this.productCertification = {
      loading: false,
      data: [],
      total: 0,
      error: null,
    };

    this.productTesting = {
      loading: false,
      data: [],
      total: 0,
      error: null,
    };

    this.expiringReports = {
      loading: false,
      data: [],
      total: 0,
      error: null,
    };
  }
}
